import React, { FC } from 'react';
import { useModal } from 'store/modal';
import Button from 'components/Button';
import TooltipWrapper from 'components/TooltipWrapper';
import { formatDate } from 'utils/helpers/formatters';
import { useTranslation } from 'react-i18next';
import { FaInfoCircle } from 'react-icons/fa';

interface IProps {
  buttonText: string;
  disabled: boolean;
  fetchedData?: any;
}

const InformationDoc: FC<IProps> = ({ buttonText, disabled, fetchedData }: IProps) => {
  const { t } = useTranslation();
  const { showModal } = useModal();

  // Get document info
  const handleInfo = () => {
    if (fetchedData && fetchedData.length > 0) {
      const data = fetchedData[0];
      showModal({
        type: 'info',
        content: (
          <div className="d-flex flex-column">
            <h2 className="mb-3">{data.name}</h2>
            <p className="mb-1">{`${t('documents.table.category')}: ${data.category_name}`}</p>
            <p className="mb-1">{`${t('documents.table.author')}: ${data.creator_name}`}</p>
            <p className="mb-1">{`${t('documents.table.group')}: ${data.group_names.join(', ')}`}</p>
            <p className="mb-1">{`${t('documents.table.createdAt')}: ${formatDate(
              new Date(data.created_at),
              'dd.mm.YYY hh:ii:ss'
            )}`}</p>
          </div>
        ),
      });
    } else {
      showModal({
        type: 'error',
        content: t('error.noData'),
      });
    }
  };

  return (
    <div className="d-inline-block ml-3">
      <TooltipWrapper
        id="tooltip-info"
        overlay={buttonText}
      >
        <Button
          type="button"
          btnType="icon"
          disabled={disabled}
          onClick={e => {
            handleInfo();
            e.stopPropagation();
          }}
        >
          <FaInfoCircle size={18} />
        </Button>
      </TooltipWrapper>
    </div>
  );
};

export default InformationDoc;
